$(() => {
  $('#id_address').on('keypress', (e) => {
    if (e.key == 'Enter') {
      $('#filter-form').trigger('submit');
    }
  });
});
